import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {PaymentMethodType, ValidateRequest} from "@features/settings/model/payments.model";
import {GenericService} from "@ui-kit/framework/common/generic.service";
import {Observable} from "rxjs";
import {PaymentModel, Retailer, RetailerBankingDetails, RetailerBillingDetails} from "../retailers.model";

@Injectable({
  providedIn: 'root'
})
export class RetailerViewService extends GenericService<Retailer> {

  constructor(http: HttpClient) {
    super(http, environment.apiRetailersHost + `/console/manage-retailer`);
  }

  getRetailerDetails(id: string): Observable<Retailer> {
    return this.http.get<Retailer>(this.getBaseUrl(id) + `/details`);
  }

  getRetailerBillingDetails(id: string): Observable<RetailerBillingDetails> {
    return this.http.get<RetailerBillingDetails>(this.getBaseUrl(id) + `/billing`);
  }

  updateRetailerBillingDetails(id: string, request: RetailerBillingDetails): Observable<RetailerBillingDetails> {
    return this.http.post<RetailerBillingDetails>(this.getBaseUrl(id) + `/billing`, request)
  }

  getRetailerBankingDetails(id: string): Observable<RetailerBankingDetails[]> {
    return this.http.get<RetailerBankingDetails[]>(this.getBaseUrl(id) + `/banking`);
  }

  getPaymentMethodOptions(id: string): Observable<PaymentMethodType[]>  {
    return this.http.get<PaymentMethodType[]>(this.getBaseUrl(id) + `/banking/options`);
  }

  validateRetailerBankingDetails(id: string, request: ValidateRequest): Observable<string> {
    return this.http.post<string>(this.getBaseUrl(id) + `/banking/validate`, request);
  }

  updateRetailerBankingDetailsRequestOTP(id: string): Observable<void> {
    return this.http.get<void>(this.getBaseUrl(id) + `/banking/create-request`);
  }

  updateRetailerBankingDetailsConfirm(id: string, otp: string, request: PaymentModel): Observable<RetailerBankingDetails> {
    return this.http.post<RetailerBankingDetails>(this.getBaseUrl(id) + `/banking/create-confirm/${otp}`, request);
  }

  removeRetailerBankingDetails(id: string, paymentMethodId: string): Observable<void> {
    return this.http.delete<void>(this.getBaseUrl(id) + `/banking/${paymentMethodId}`);
  }

  getBaseUrl(retailerId: string) {
    return environment.apiRetailersHost + `/console/manage-retailer/${retailerId}`;
  }

  updateRetailer(retailerId: string, request: any): Observable<Retailer> {
    return this.http.post<Retailer>(`${this.getBaseUrl(retailerId)}`, request);
  }


}
